<p-sidebar
    id="app-sidebar"
    [visible]="isVisible"
    [showCloseIcon]="false"
    [styleClass]="
        isCollapsed
            ? hasScrollbar
                ? 'app-sidebar collapsed has-scrollbar'
                : 'app-sidebar collapsed'
            : 'app-sidebar expanded'
    "
    position="left"
    [modal]="false">
    <div id="sidebar-header">
        <a [href]="quickorderDashboardUrl">
            <img src="assets/images/app-logo.svg" id="app-logo-sidebar" alt="app-logo" />
        </a>
        <div>
            <p id="app-title">CheckMate</p>
            <p id="app-subtitle">Transnetyx</p>
        </div>
    </div>

    <div id="sidebar-content">
        <app-navigation [isSidebarCollapsed]="isCollapsed" (toggleIsCollapsed)="toggleIsCollapsed()"></app-navigation>
    </div>

    <div
        id="collapse-area"
        (click)="toggleIsCollapsed()"
        [ngClass]="isCollapsed ? 'collapse-area-c' : 'collapse-area-e'">
        <button pButton class="p-button-rounded p-button-text" aria-label="Toggle sidebar">
            <i class="fa-thin fa-angle-right" [class]="isCollapsed ? 'collapsed' : 'expanded'"></i>
        </button>
    </div>
</p-sidebar>
